import { render, staticRenderFns } from "./ItemsPerPageSelect.vue?vue&type=template&id=e1368870&scoped=true&"
import script from "./ItemsPerPageSelect.vue?vue&type=script&lang=ts&"
export * from "./ItemsPerPageSelect.vue?vue&type=script&lang=ts&"
import style0 from "./ItemsPerPageSelect.vue?vue&type=style&index=0&id=e1368870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1368870",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
